<template>
  <div>
    <Row class="current">
      <Col
        span="24"
        v-for="item in tableData.data"
        :key="item.id"
        class="current-block"
      >
        <Row class="current-top">
          <Col span="21" class="name">{{ item.name }}</Col>
          <!----
        考试训练类：
        item.exam_info: 报名信息( 点击参加即为报名！！ )
        ------- 未开始
        status==2 || status==3 && isDuringDate(item.restrict_begin_time, item.restrict_end_time)==false
        ------- 去考试
        status==3 && isDuringDate(item.restrict_begin_time, item.restrict_end_time) && (item.is_grade_flag==1)
        status==3 && isDuringDate(item.restrict_begin_time, item.restrict_end_time) && (item.is_grade_flag==2 && isGrade(item.selected_grade_ids))

        是否设置报名学生范围，1否，2是
        selected_grade_ids 选中的级别
        ------- 已交卷
        ------- 未参加
        item.status >3&&!item.exam_info
          -->
          <Col span="3" class="right" v-if="item.type <= 2">
            <Button
              v-if="
                item.status == 3 &&
                  item.exam_info &&
                  item.exam_info.status == 1 &&
                  isDuringDate(item.restrict_begin_time, item.restrict_end_time)
              "
              type="primary"
              html-type="submit"
              @click="
                $router.push(
                  '/myExam/exam?examination_id=' +
                    item.exam_info.examination_id +
                    '&id=' +
                    item.exam_info.id
                )
              "
              >去考试</Button
            >
            <Button
              v-if="
                item.status == 3 &&
                  item.exam_info &&
                  item.exam_info.status == 2 &&
                  isDuringDate(item.restrict_begin_time, item.restrict_end_time)
              "
              type="primary"
              html-type="submit"
              @click="
                $router.push(
                  '/myExam/exam?examination_id=' +
                    item.exam_info.examination_id +
                    '&id=' +
                    item.exam_info.id
                )
              "
              >去考试</Button
            >
            <Button
              v-if="
                item.type == 2 &&
                  item.status == 1 &&
                  !item.exam_info &&
                  isDuringDate(item.enroll_start_time, item.enroll_end_time)
              "
              type="primary"
              html-type="submit"
              @click="signUp(item)"
              >去报名</Button
            >
            <span v-if="item.status > 2 && !item.exam_info">未报名</span>
            <span
              v-if="
                item.type == 2 &&
                  item.status == 1 &&
                  validTime(item.enroll_start_time, newdate)
              "
              >报名未开始</span
            >
            <span
              v-if="
                item.status == 2 ||
                  (item.type == 1 && item.status == 1) ||
                  (item.type == 2 && item.status == 1 && item.exam_info) ||
                    (item.type == 2 &&
                      item.status < 4 &&
                      validTime(newdate, item.enroll_end_time) &&
                      validTime(item.restrict_begin_time, newdate))
              "
              >考试未开启</span
            >
            <span
              v-if="
                item.status > 3 && item.exam_info && item.exam_info.status == 1
              "
              >缺考</span
            >
            <span v-if="item.exam_info && item.exam_info.status == 3"
              >已交卷</span
            >
          </Col>

          <Col span="3" class="right" v-if="item.type == 3">
            <p
              v-if="
                item.status == 3 &&
                  !item.exam_info &&
                  (item.is_grade_flag == 1 ||
                    (item.is_grade_flag == 2 &&
                      isGrade(item.applicable_scope))) &&
                  isDuringDate(item.restrict_begin_time, item.restrict_end_time)
              "
            >
              <Button
                type="primary"
                html-type="submit"
                @click="$router.push('/myExam/exam2?examination_id=' + item.id)"
                >去考试</Button
              >
            </p>
            <p
              v-else-if="
                item.status == 3 &&
                  item.exam_info &&
                  item.exam_info.status == 2 &&
                  (item.is_grade_flag == 1 ||
                    (item.is_grade_flag == 2 &&
                      isGrade(item.applicable_scope))) &&
                  isDuringDate(item.restrict_begin_time, item.restrict_end_time)
              "
            >
              <Button
                type="primary"
                html-type="submit"
                @click="$router.push('/myExam/exam2?examination_id=' + item.id)"
                >去考试</Button
              >
            </p>
            <p
              v-else-if="
                item.status == 2 ||
                  (item.status == 3 &&
                    validTime(item.restrict_begin_time, newdate))
              "
            >
              考试未开启
            </p>
            <p
              v-else-if="
                item.status == 2 ||
                  (item.status == 3 &&
                    validTime(newdate, item.restrict_end_time))
              "
            ></p>
            <p v-else-if="item.status > 3 && !item.exam_info">未参加</p>
            <p v-else-if="item.exam_info && item.exam_info.status == 3">
              已交卷
            </p>
          </Col>
        </Row>

        <Row class="current-con">
          <Col span="21">
            <div>
              考试时间:{{ item.restrict_begin_time }}&nbsp;-&nbsp;{{
                item.restrict_end_time
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 考试时长:{{
                item.time_limit
              }}分钟&nbsp;
              <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              考试地点:{{item.restrict_begin_time}}&nbsp; -->
            </div>
            <div v-if="item.type == 2">
              报名时间:{{ item.enroll_start_time }}&nbsp;-&nbsp;{{
                item.enroll_end_time
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 报名情况:{{
                item.enrolled_count
              }}<span v-if="item.enroll_max_stu_count"
                >/{{ item.enroll_max_stu_count }}</span
              >&nbsp;
            </div>
          </Col>
          <Col span="3" class="right">
            <img
              v-if="
                item.type == 2 &&
                  item.status == 1 &&
                  validTime(item.enroll_start_time, newdate)
              "
              :src="baomingweikaishi"
              alt=""
            />

            <img
              v-else-if="
                item.status == 3 &&
                  isDuringDate(item.restrict_begin_time, item.restrict_end_time)
              "
              :src="examing"
              alt=""
            />
            <img
              v-else-if="
                item.type == 2 &&
                  item.status == 1 &&
                  isDuringDate(item.enroll_start_time, item.enroll_end_time)
              "
              :src="baomingzhong"
              alt=""
            />

            <!-- validTime(newdate,item.enroll_end_time)&& -->
            <img
              v-else-if="
                item.status == 2 ||
                  (item.type == 1 && item.status < 4) ||
                  (item.type == 2 &&
                    item.status < 4 &&
                    validTime(item.restrict_begin_time, newdate))
              "
              :src="kaoshiweikaishi"
              alt=""
            />

            <img v-else :src="baomingjieshu" alt="" />
          </Col>
        </Row>
      </Col>
    </Row>
    <Page
      style="text-align: right;margin-bottom:10px"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
    <Modal v-model="lookShow" @on-cancel="lookShow = false" title="报名">
      <Row class="baoming">
        <Col span="24" class="baomingdiv">
          <p style="color:#000">{{ looksInfo.name }}</p>
          <div>考试时间：{{ looksInfo.begin_time }}</div>
          <div>考试时长：{{ looksInfo.time_limit }}分钟</div>
          <div>
            报名时间：{{ looksInfo.enroll_start_time }}&nbsp;-&nbsp;{{
              looksInfo.enroll_end_time
            }}
          </div>
          <div>
            报名情况：{{ looksInfo.enrolled_count
            }}<span v-if="looksInfo.enroll_max_stu_count"
              >/{{ looksInfo.enroll_max_stu_count }}</span
            >（已报名人数/报名人数上限）
          </div>
        </Col>
        <Col span="24" class="baomingdiv" style="border:0">
          <p>我的报名情况</p>
          <div>
            时间范围：{{ looksInfo.restrict_begin_time }}&nbsp;-&nbsp;{{
              looksInfo.restrict_end_time
            }}
          </div>
          <div>可报名总次数：{{ total_count }}次</div>
          <div>剩余报名次数：{{ left_count }}次</div>
          <div>报名所需积分：{{ looksInfo.price }}</div>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="lookShow = false">取消</Button>
        <Button type="primary" size="small" @click="signUpOk()">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import indexPage from "../../mixins/indexPage";
export default {
  data() {
    return {
      searchData: {
        exam_status: 1,
        grade_id: "",
        subject_id: ""
      },
      newdate: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      total_count: 0,
      left_count: 0,
      examing: require("@/assets/images/examing.png"),
      baomingweikaishi: require("@/assets/images/baomingzhong.png"),
      baomingzhong: require("@/assets/images/enrolling.png"),
      baomingjieshu: require("@/assets/images/examend.png"),
      kaoshiweikaishi: require("@/assets/images/examnotstart.png"),
      looksInfo: {},
      lookShow: false,
      tableColumns: [
        { title: "ID", key: "id", align: "center", maxWidth: 80 },
        { title: "面授课程", key: "name", align: "center" },
        { title: "任教老师", key: "teacher_name", align: "center" },
        { title: "上课时间", key: "learningTime", align: "center" },
        { title: "原价", key: "original_price", align: "center" },
        { title: "售价", key: "current_price", align: "center" },
        { title: "报名人数上限", key: "apply_num_limit", align: "center" },
        // { title: "已报名人数", key: "period", align: "center"},
        { title: "操作", slot: "action", minWidth: 60, align: "center" }
      ],
      indexUrl: "/app/examination/index",
      userinfo: {} //当前登录用户信息
    };
  },
  mixins: [indexPage],
  props: {
    reSearch: {
      type: Object,
      default: () => ({
        name: "",
        exam_status: 1
      })
    }
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  methods: {
    search() {
      if (this.reSearch) {
        this.searchData.name = this.reSearch.name;
        this.searchData.grade_id = this.reSearch.grade_id;
        this.searchData.subject_id = this.reSearch.subject_id;
      }
      this.$forceUpdate();
    },
    validTime(beginDateStr, endDateStr) {
      var beginDate = Number(new Date(beginDateStr).getTime());
      var endDate = Number(new Date(endDateStr).getTime());
      if (endDate <= beginDate) {
        return true;
      }
      return false;
    },
    isDuringDate(beginDateStr, endDateStr) {
      var newdate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      var beginDate = Number(new Date(beginDateStr).getTime());
      var curDate = Number(new Date(newdate).getTime());
      var endDate = Number(new Date(endDateStr).getTime());
      if (curDate - beginDate >= 0 && endDate - curDate >= 0) {
        return true;
      }
      return false;
    },
    signUp(row) {
      this.looksInfo = {};
      this.looksInfo = row;
      this.$axios
        .post("/app/enrollment_time/getCount?examination_id=" + row.id)
        .then(res => {
          if (res.code == 1) {
            this.left_count = res.data.left_count;
            this.total_count = res.data.total_count;
          } else {
            this.$Message.error(res.msg);
          }
        });
      this.lookShow = true;
    },
    signUpOk() {
      var that = this;
      that.$axios
        .post("/app/examination/apply?examination_id=" + that.looksInfo.id)
        .then(res => {
          if (res.code == 1) {
            that.lookShow = false;
            that.$Message.success("报名成功");
            that.getData(that.tableData.current_page);
          } else {
            that.$Message.error(res.msg);
          }
        });
    },
    isGrade(applicable_scope) {

      //判断当前用户的学员级别是否在当前考试的学员级别中 cjp
      if (applicable_scope.grade_ids == null || applicable_scope.grade_ids.length == 0) {
        return true;
      }
      if (this.userInfo.grade_ids == null || this.userInfo.grade_ids == "") {
        return false;
      }
      let bz = false;
      let arr1 = applicable_scope.grade_ids;
      let arr2 = this.userInfo.grade_ids.split(",");
      arr1.forEach(el => {
        arr2.forEach(el2 => {
          if (el == el2) bz = true;
        });
      });
      return bz;
    }
  }
};
</script>
<style scoped lang="less">
.group-name:nth-child(n + 2)::before {
  content: " / ";
}
.current {
  // width: 80%;
  padding: 0 10px;
  background: #fff;
  height: 70vh;
  overflow-y: scroll;
  .current-block {
    border: 1px solid #eee;
    border-top: 5px solid #2d8cf0;
    border-radius: 8px;
    color: #222;
    margin-bottom: 15px;
    .current-top {
      padding: 10px 10px 6px 30px;
      border-bottom: 1px solid #eee;
      .name {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .current-con {
      padding: 10px 10px 10px 30px;
      div {
        line-height: 2;
        font-size: 16px;
      }
    }
    .right {
      text-align: right;
      text-align: center;
    }
  }
}
.baoming {
  padding: 10px;
  .baomingdiv {
    line-height: 2.2;
    border-bottom: 3px dotted #999;
    font-size: 15px;
    p {
      font-size: 24px;
      color: #444;
    }
  }
}
</style>
